/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import AccionaLogo from '../../../../style/img/logo.png';
import styles from './index.module.scss';
import { MainContext } from '../../../../context/MainContext';
import { ReactComponent as IconUser } from '../../../../style/img/icon_user_dark.svg';
import { useIntl } from 'react-intl';
import { Button, Dropdown, Layout } from 'antd';
import {
  BarsOutlined,
  LogoutOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getLogout } from '../../../../services/redux/auth/actions';
import { useLocation, useNavigate } from 'react-router-dom';

const { header, logo, userZone } = styles;
const { Header: AntdHeader } = Layout;

const Header = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { project } = useContext(MainContext);
  const { me } = useSelector(({ auth }) => auth);

  return (
    <AntdHeader className={header}>
      <div>
        <img src={AccionaLogo} alt="Acciona Logo" className={logo} />
      </div>
      <div>
        {project &&
          !pathname.includes('projects') &&
          !pathname.includes('users') &&
          intl.formatMessage(
            { id: 'header.project' },
            {
              center: project.name,
              code: project.work_code,
            },
          )}
      </div>
      <div>
        <Button
          color="primary"
          icon={<BarsOutlined />}
          onClick={() => {
            navigate('/app/projects');
          }}
        >
          {intl.formatMessage({ id: 'header.projects' }).toLocaleUpperCase()}
        </Button>
        <div className={userZone}>
          <Dropdown
            position="bottom"
            menu={{
              items: [
                {
                  key: 'profile',
                  label: (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/app/profile');
                      }}
                    >
                      <UserOutlined />{' '}
                      {intl.formatMessage({ id: 'routes.profile' })}
                    </a>
                  ),
                },
                ...(me?.role === 'ADMIN'
                  ? [
                      {
                        key: 'users',
                        label: (
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              dispatch(navigate('/app/users'));
                            }}
                          >
                            <TeamOutlined />{' '}
                            {intl.formatMessage({ id: 'routes.users' })}
                          </a>
                        ),
                      },
                    ]
                  : []),
                {
                  key: 'logout',
                  label: (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(getLogout());
                      }}
                    >
                      <LogoutOutlined />{' '}
                      {intl.formatMessage({ id: 'header.logout' })}
                    </a>
                  ),
                },
              ],
            }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <IconUser /> {me?.name}
            </a>
          </Dropdown>
        </div>
      </div>
    </AntdHeader>
  );
};

export default Header;
